import React, { FC } from "react";

import ToolTip from "newComponents/Shared/_Atoms/ToolTip/ToolTip";
import Icon from "newComponents/Shared/_Atoms/Icons/Icon/Icon";
import colors from "constants/colors";

interface IProps {
  info: string | React.ReactNode;
  style?: React.CSSProperties;
  horizontal?: boolean;
  toolTipStyle?: React.CSSProperties;
  white?: boolean;
  color?: string;
}

const InfoIcon: FC<IProps> = ({ info, style, horizontal, toolTipStyle, white, color }) => {
  return (
    <div className="info-icon-container" style={style}>
      <ToolTip tips={info} horizontal={horizontal} style={toolTipStyle} white={white}>
        <Icon icon="info-circle" color={color || colors.black} />
      </ToolTip>
    </div>
  );
};

export default InfoIcon;
